import { CommApiInstance } from "Utils/CommApiInstance";

const MembOtpAthnApi = async (
    otpAthnNo:string,
    cptchTkn: string,
) => {
    return await CommApiInstance.post(`athn/otp/athn`,{
        apiBody:{
            otpAthnNo:otpAthnNo,
            cptchTkn:cptchTkn,
        },
    })
    .then((Resp) => Resp.data);
}
export default MembOtpAthnApi;